import translator from '@Components/Utilities/Translator';
import Combobox from '@Components/MuiWrappers/Combobox';
import Box from '@mui/material/Box';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const TimeZoneSelector = (props) => {
    const routes = useRecoilValue(atoms.routes);

    const getOptionLabel = (option) => {
        return option.Text ? option.Text : option.Value;
    };

    const renderOption = (optionsProps, option) => {
        var dropdownOption = {
            Text: option.Text,
            Value: option.Value
        };
        return (
            <Box component="li" {...optionsProps}>
                <div><span>{getOptionLabel(dropdownOption)}</span></div>
            </Box>
        );
    };

    const onChange = (event, option, reason, details) => {
        if (reason == 'selectOption') {
            const timeZone = option.Value;
            if (props.onChange) {
                props.onChange(timeZone);
            }
        }
    };

    const valueTimeZone = (value) => {
        for (let i = 0; i < props.ValidTimeZones.length; i++) {
            if (props.ValidTimeZones[i].Value === value) {
                return props.ValidTimeZones[i];
            }
        }
    };
    return (
        <div className={props.containerClassName}>
            <Combobox
                label={translator.translate('sandhills.tradesites.mvc.selectyourtimezone')}
                value={valueTimeZone(props.value)}
                options={props.ValidTimeZones}
                getOptionLabel={getOptionLabel}
                renderOption={renderOption}
                onChange={onChange}
            />
        </div>
    );
};

export default TimeZoneSelector;